import type {
  Validations,
  SMSChatbotState,
  SMSChatbotApi,
} from 'src/types/sms-chatbot';
import {
  normalizeNodeSchedule,
  parseNodeSchedule,
} from 'src/utils/node-schedule';


export const parseSMSChatbot = (
  fetchedNodeResponse: SMSChatbotApi,
): SMSChatbotState => {
  const smsChatbotParams = fetchedNodeResponse.task.params;
  const nodeSchedule = parseNodeSchedule(fetchedNodeResponse);

  const toNumber = smsChatbotParams.to_number;
  if (toNumber == null) {
    throw new Error(
      'to_number field should be present in sms chatbot node response',
    );
  }

  return {
    flow_id: smsChatbotParams.flow_id,
    to_number:
      toNumber.startsWith('{{') && toNumber.endsWith('}}')
        ? toNumber
        : `{{${toNumber}}}`,
    ...nodeSchedule,
  };
};

export const normalizeSMSChatbot = (
  payload: SMSChatbotState,
): SMSChatbotApi => {
  const {to_number, flow_id} = payload;
  const nodeSchedule = normalizeNodeSchedule(payload);
  return {
    task: {
      params: {
        to_number,
        flow_id,
      },
    },
    ...nodeSchedule,
  };
};

export const getErrors = (validationsObject: Validations): Array<string> => {
  const errors: Array<string> = [];
  const {sendToNumberEmpty, invalidToNumber} = validationsObject;
  if (sendToNumberEmpty) {
    errors.push('Please fill the required fields.');
  }
  if (invalidToNumber) {
    errors.push('Send to number is Invalid.');
  }
  return errors;
};
